import React, { useContext } from 'react';
import { LoadingContext } from '../../context/Loading/LoadingContext';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { api } from 'services/api';

interface Tprops {
  path: string;
  itemExclude: string;
  open: boolean;
  setOpen: (boolean) => void;
}

const ModalDelete = ({ path, itemExclude, open, setOpen }: Tprops) => {
  const { setLoading, setLoadingMensagem, setLoadingBtn }: any = useContext(LoadingContext);

  const handleClose = () => {
    setOpen(false);
  };

  const handclick = async () => {
    handleClose();
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    ApiRequest();
    async function ApiRequest() {
      setLoading(true);
      await api
        .delete(path + itemExclude)
        .then(() => (setLoading(false), window.location.reload()))
        .catch((e) => {
          let msg = 'Houve um erro interno, tente mais tarde. ' + e.message;
          if (e.code === 'ERR_BAD_REQUEST') msg = 'Usuário sem autenticação';

          setLoadingMensagem(msg);
          setLoadingBtn('OK');
        });
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Confirmação de exclusão</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" textAlign={'center'} fontWeight={'600'} color={'#136033'}>
          Deseja excluir esse campo da tabela?
        </DialogContentText>
      </DialogContent>
      <DialogActions className="modal-btn-action-box">
        <Button onClick={handleClose} autoFocus className="btn-person btn-cinza">
          NÃO
        </Button>
        <Button onClick={handclick} className="btn-person btn-verde">
          SIM
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalDelete;
